import {AfterViewInit, Component, EventEmitter, Inject, OnInit, ViewChild} from '@angular/core';
import {DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';
import _ from 'lodash';

@Component({
  selector: 'trusted-certificate-dialog',
  templateUrl: './trusted-certificate-dialog.component.html',
  styleUrls: ['./trusted-certificate-dialog.component.scss']
})
export class TrustedCertificateDialogComponent implements OnInit, AfterViewInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  errorMessage = '';

  data;

  @ViewChild('mapForm') trustedCertificateForm: NgForm;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.data = dialogConfig.dialogData.certificateToAdd;
    dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.trustedCertificateForm.form.statusChanges.subscribe(() => {
      this.setSubmitButtonDisabled();
    });
  }

  onFileChange(files): any {
    if (files && files.length === 1) {

      const fileReader: FileReader = new FileReader();
      fileReader.onloadend = () => {
        this.data.value = fileReader.result;
        this.setSubmitButtonDisabled();
      };
      fileReader.onerror = () => {
        this.data.value = '';
        this.errorMessage = fileReader.result as string;
      };
      fileReader.readAsText(files[0]);
    }
  }

  private setSubmitButtonDisabled(): void {
    this.dialogConfig.submitButtonDisabled = !this.trustedCertificateForm.form.valid || _.isEmpty(this.data.value);
  }
}
